import type { FormatCurrencyProps } from './types'

/**
 * This is a simple wrapper around `Intl.NumberFormat` that automatically
 * chooses a locale and formats `value` as `currency`.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/format
 */
export const formatCurrencyAmount = ({
  compactNotation = false,
  currency,
  value,
}: FormatCurrencyProps): string => {
  if (Number.isNaN(value)) {
    console.warn(
      `Passed a non-Number 'value' (${value}) to formatCurrencyAmount`
    )
    return value.toString()
  }

  return new Intl.NumberFormat(navigator.language, {
    currency,
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
    notation: compactNotation ? 'compact' : 'standard',
    style: 'currency',
  }).format(value)
}
